/* eslint-disable react/prop-types */
import { Cancel } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tab,
  Tabs,
  Link,
  Typography,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import theme from "assets/theme";
import {
  PaperComponent,
  validateArrayFileRequired,
  API_URL_DOWNLOAD,
  checkUrlTep,
} from "utils/constants";
import { DownloadIcon, InfoIcon } from "@primer/octicons-react";
import DescriptionIcon from "@mui/icons-material/Description";
import { JsonTool } from "utils/jsonTools";
import CustomTabPanel from "components/CustomPanel/customPanel";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { AlertState, SettingState } from "states";
import { Fragment, useEffect, useMemo, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDBadge from "components/MDBadge";
import AddListFile from "components/AddListFile";
import SaveIcon from "@mui/icons-material/Save";
import CustomFieldForm from "components/CustomFieldForm";
import dayjs from "dayjs";

const dictTrangThai = {
  1: "Đang chấm",
  2: "Đã hoàn thành",
};
const dictColorTrangThai = {
  1: "success",
  2: "warning",
};
function TongHopPhieuDiem({
  data,
  open,
  onClose,
  onSave,
  validationErrors,
  seen,
}) {
  const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const setAlert = useSetRecoilState(AlertState);
  const [tab, setTab] = useState(0);
  const [errors, setErrors] = useState({});
  const [dataChangeState, setDataChangeState] = useState();
  const settingState = useRecoilValue(SettingState);
  //state file
  const [fileDel, setFileDel] = useState([]);
  const [fileFields, setFileFields] = useState([]);
  const [fileEditName, setFileEditName] = useState({});

  //effect
  useEffect(() => {
    if (data && data.id) {
      setDataChangeState({
        ngay: data?.ngay,
        soquyetdinh: data?.soquyetdinh || "",
        ngaycham: data?.ngaycham,
        noidung: data?.noidung || "",
      });
    }
  }, [data]);

  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);
  useEffect(() => {
    if (open) {
      setErrors({});
      setTab(0);
      setFileDel([]);
      setFileFields([]);
      setFileEditName({});
    }
  }, [open]);

  //onChange
  const handelClear = () => {
    onClose();
  };
  const handleChange = (event, newValue) => {
    setTab(newValue);
  };
  const handleErrorDownload = (mess) => {
    setAlert({
      alert: true,
      message: mess,
      type: "error",
    });
  };

  //trường thông tin của phiếu
  const dataInfor = useMemo(() => {
    const resultNotSeen = [
      {
        key: "phieudangky__noidung",
        name: "Phiếu đăng ký",
      },
      {
        key: "hoidong__soquyetdinh",
        name: "Hội đồng",
      },
      {
        key: "trangthai_ten",
        name: "Trạng thái",
      },
      {
        key: "tongdiem",
        name: "Tổng điểm",
      },
    ];
    const resultSeen = [
      {
        key: "soquyetdinh",
        name: "Số quyết định",
      },
      {
        key: "ngay",
        name: "Ngày ban hành",
      },
      {
        key: "ngaycham",
        name: "Ngày chấm",
      },
      {
        key: "phieudangky__noidung",
        name: "Phiếu đăng ký",
      },
      {
        key: "hoidong__soquyetdinh",
        name: "Hội đồng",
      },
      {
        key: "trangthai_ten",
        name: "Trạng thái",
      },
      {
        key: "tongdiem",
        name: "Tổng điểm",
      },
      {
        key: "noidung",
        name: "Nội dung",
      },
    ];
    return seen ? resultSeen : resultNotSeen;
  }, [seen]);

  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = {
      id: data?.id,
      hoidong: data?.hoidong,
      phieudangky: data?.phieudangky,
      soquyetdinh: dataChangeState?.soquyetdinh,
      noidung: dataChangeState?.noidung,
    };
    _data["fileDel"] = fileDel;

    const listFormatDate = ["ngay", "ngaycham"];
    listFormatDate?.forEach((field) => {
      _data[field] =
        dataChangeState?.[field] &&
        !errors?.[field] &&
        dayjs(dataChangeState?.[field])?.isValid()
          ? dayjs(dataChangeState?.[field]).format("YYYY-MM-DD")
          : null;
    });
    _data["tentepdinhkem"] = fileFields?.map((item) => item?.filename) || [];
    _data["tepdinhkemValidate"] = fileFields?.map((item) => item?.file) || [];
    _data["tentepdinhkemEdit"] = Object.values(fileEditName);
    const newValidationErrors = validateOBJ(
      _data,
      settingState["dungluong_file_upload"]
    );
    let _tempValid = newValidationErrors;
    if (
      _tempValid["tepdinhkemValidate"] &&
      _tempValid["tepdinhkemValidate"].some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }
    if (
      _tempValid["tentepdinhkem"] &&
      _tempValid["tentepdinhkem"].some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }

    if (
      _tempValid["tentepdinhkemEdit"] &&
      Object.values(_tempValid["tentepdinhkemEdit"])?.length > 0 &&
      Object.values(_tempValid["tentepdinhkemEdit"]).some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }

    delete _tempValid["tentepdinhkem"];
    delete _tempValid["tepdinhkemValidate"];
    delete _tempValid["tentepdinhkemEdit"];
    delete _data["tepdinhkemValidate"];
    if (Object.values(_tempValid).some((error) => error)) {
      setErrors((prev) => ({
        ...prev,
        ...newValidationErrors,
      }));
      return;
    }
    let listName = [];
    fileFields?.forEach((item) => {
      if (!item?.remove) {
        listName.push(item?.filename);
      }
    });
    _data["tentepdinhkem"] = listName;
    _data["tepdinhkem"] = fileFields?.map((item) => item?.file) || [];
    onSave?.(_data);
  }

  //change file
  const handleErrorDownloadFile = (error) => {
    setAlert(error);
  };
  const handleOnDeleteFileDefault = (data) => {
    setFileDel(data);
  };
  const handleErrorFile = (error) => {
    setErrors(error);
  };
  const handleChangeFileList = (data) => {
    setFileFields(data);
  };
  const handleEditFileNameDefault = (data) => {
    setFileEditName(data);
  };

  const fieldInfor = useMemo(() => {
    let result = [
      {
        name: "Số quyết định",
        key: "soquyetdinh",
        required: true,
        type: "text",
        maxLength: 255,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Ngày ban hành",
        key: "ngay",
        type: "date",
        required: true,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Ngày chấm",
        key: "ngaycham",
        type: "date",
        required: true,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Nội dung",
        key: "noidung",
        type: "textArea",
        required: true,
        xs: 12,
        md: 12,
        lg: 12,
      },
    ];
    return result;
  }, []);
  //onChange thong tin
  const handleChangeDataState = (data) => {
    let { name, value } = data;
    setDataChangeState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleErrorDataState = (error) => {
    let { name, value } = error;
    setErrors((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    data && (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        PaperComponent={PaperComponent}
        onClose={handelClear}
        scroll="paper"
        PaperProps={{
          sx: {
            "@media (min-width: 768px)": {
              minWidth: "50rem",
            },
            height: "100%",
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
          Tổng hợp phiếu điểm
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            position: "sticky",
            top: 0,
            backgroundColor: "#ffffff",
          }}
        >
          <Tabs value={tab} onChange={handleChange}>
            <Tab
              icon={<InfoIcon />}
              label="Thông tin"
              {...JsonTool.a11yProps(0)}
            />
            <Tab
              icon={<DescriptionIcon />}
              label="Tệp đính kèm"
              {...JsonTool.a11yProps(1)}
            />
          </Tabs>
        </Box>
        <DialogContent dividers sx={{ overflow: "auto", paddingTop: "0" }}>
          <CustomTabPanel value={tab} index={0}>
            <div className="text-base mb-3 font-semibold text-gray-950">
              Thông tin phiếu chấm
            </div>
            {!seen && (
              <div className="mb-4">
                {fieldInfor?.length > 0 && (
                  <CustomFieldForm
                    key={"fieldInforTongHopPhieuDiem"}
                    listField={fieldInfor}
                    data={dataChangeState}
                    onChange={handleChangeDataState}
                    onError={handleErrorDataState}
                    errorValues={errors}
                    listOptionDic={{}}
                  />
                )}
              </div>
            )}
            <div className="ml-2 pt-3">
              <Grid
                container
                spacing={1}
                sx={{
                  border: "1px solid #d6d6d6",
                  borderRadius: "0.5rem",
                  color: "#121212",
                  padding: "0.5rem",
                }}
              >
                {dataInfor.map((item, index) => (
                  <Fragment key={item?.key + index + "inforchamdiem"}>
                    <Grid item xs={4} md={2} lg={2}>
                      <Typography fontSize={"0.85rem"}>{item?.name}</Typography>
                    </Grid>
                    <Grid item xs={8} md={4} lg={4}>
                      <Typography fontSize={"1rem"} fontWeight={700}>
                        {data?.[item?.key]
                          ? data?.[item?.key]
                          : "Đang cập nhập..."}
                      </Typography>
                    </Grid>
                  </Fragment>
                ))}
              </Grid>
            </div>
            <div className="mt-4">
              <div className="text-base mb-3 font-semibold text-gray-950">
                Thành viên
              </div>
              <div>
                {data?.thanhvien && data?.thanhvien?.length > 0 ? (
                  data?.thanhvien?.map((thanhvien, index) => {
                    let tongDiem = 0;
                    if (thanhvien?.tieuchi && thanhvien?.tieuchi?.length > 0) {
                      tongDiem = thanhvien?.tieuchi?.reduce(
                        (total, item) => total + item.diem,
                        0
                      );
                    }
                    return (
                      <Accordion
                        key={
                          thanhvien?.id + "_thanhvien_" + thanhvien?.thanhvien
                        }
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          style={{ backgroundColor: "#d3d6f7" }}
                        >
                          <div className="flex justify-between w-full font-semibold">
                            <div>
                              {thanhvien?.thanhvien__ten} -{" "}
                              <span>Tổng điểm: {tongDiem} điểm</span>
                            </div>
                            <div className="mr-3">
                              <MDBadge
                                badgeContent={
                                  dictTrangThai[thanhvien?.trangthai]
                                }
                                color={dictColorTrangThai[thanhvien?.trangthai]}
                                variant="gradient"
                              />
                            </div>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div>
                            <div className="font-semibold">
                              Nội dung tiêu chí
                            </div>
                            {thanhvien?.tieuchi &&
                              thanhvien?.tieuchi?.length > 0 && (
                                <ul className="space-y-1 text-gray-500 list-disc list-inside dark:text-gray-400">
                                  {thanhvien?.tieuchi?.map((tieuchi) => {
                                    return (
                                      <li key={"botieuchi" + tieuchi?.id}>
                                        <span>{`[${tieuchi?.diem} điểm]`}</span>
                                        {" - "}
                                        {tieuchi?.botieuchi__ten}
                                      </li>
                                    );
                                  })}
                                </ul>
                              )}
                          </div>
                          <div className="mt-2 pt-2 border-t border-gray-200">
                            <div className="font-semibold">Ý kiến đánh giá</div>
                            <div className="mt-2">
                              {thanhvien?.ykiendanhgia}
                            </div>
                          </div>
                          {thanhvien?.tepdinhkem &&
                            thanhvien?.tepdinhkem?.length > 0 && (
                              <div className="mt-2 pt-2 border-t border-gray-200">
                                <div className="font-semibold">
                                  Tệp đính kèm
                                </div>
                                <Grid container>
                                  <Grid
                                    container
                                    style={{
                                      color: "#000000",
                                      backgroundColor: "#c6e3fa",
                                    }}
                                    fontSize={"1rem"}
                                    fontWeight={600}
                                    pb={"0.5rem"}
                                    m={"0.5rem 0"}
                                    spacing={1}
                                    borderBottom={"2px solid #3F51B5"}
                                  >
                                    <Grid item xs={2}>
                                      STT
                                    </Grid>
                                    <Grid item xs={8}>
                                      Tên tệp đính kèm
                                    </Grid>
                                    <Grid item xs={2}>
                                      Tải về
                                    </Grid>
                                  </Grid>
                                  {thanhvien?.tepdinhkem?.map((tep, index) => (
                                    <Grid
                                      container
                                      key={tep?.id + index + "tepdinhkem"}
                                      style={{ color: "#000000" }}
                                      fontSize={"1rem"}
                                      borderBottom={"1px solid #d6d6d6"}
                                      pb={"0.5rem"}
                                      mb={"0.5rem"}
                                      ml={0}
                                      spacing={1}
                                    >
                                      <Grid item xs={2}>
                                        {index + 1}
                                      </Grid>
                                      <Grid item xs={8}>
                                        {tep?.tentepdinhkem}
                                      </Grid>
                                      <Grid
                                        item
                                        xs={2}
                                        display={"flex"}
                                        alignItems={"center"}
                                        justifyContent={"center"}
                                        style={{ paddingTop: "0px" }}
                                      >
                                        <Typography variant="h5" color="info">
                                          <Link
                                            target="_blank"
                                            href={
                                              API_URL_DOWNLOAD +
                                              checkUrlTep(tep?.tepdinhkem)
                                            }
                                          >
                                            <DownloadIcon />
                                          </Link>
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  ))}
                                </Grid>
                              </div>
                            )}
                        </AccordionDetails>
                      </Accordion>
                    );
                  })
                ) : (
                  <div className="w-full p-4 text-base font-semibold text-center">
                    Thông tin đang được cập nhập...
                  </div>
                )}
              </div>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={tab} index={1}>
            {seen ? (
              <>
                {data?.tepdinhkem && data?.tepdinhkem?.length > 0 ? (
                  <Grid container>
                    <Grid
                      container
                      style={{
                        color: "#000000",
                        backgroundColor: "#c6e3fa",
                      }}
                      fontSize={"1rem"}
                      fontWeight={600}
                      pb={"0.5rem"}
                      m={"0.5rem 0"}
                      spacing={1}
                      borderBottom={"2px solid #3F51B5"}
                    >
                      <Grid item xs={2}>
                        STT
                      </Grid>
                      <Grid item xs={8}>
                        Tên tệp đính kèm
                      </Grid>
                      <Grid item xs={2}>
                        Tải về
                      </Grid>
                    </Grid>
                    {data.tepdinhkem?.map((tep, index) => (
                      <Grid
                        container
                        key={tep?.id + index + "tepdinhkem"}
                        style={{ color: "#000000" }}
                        fontSize={"1rem"}
                        borderBottom={"1px solid #d6d6d6"}
                        pb={"0.5rem"}
                        mb={"0.5rem"}
                        ml={0}
                        spacing={1}
                      >
                        <Grid item xs={2}>
                          {index + 1}
                        </Grid>
                        <Grid item xs={8}>
                          {tep?.tentepdinhkem}
                        </Grid>
                        <Grid
                          item
                          xs={2}
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"center"}
                          style={{ paddingTop: "0px" }}
                        >
                          <Typography variant="h5" color="info">
                            <Link
                              target="_blank"
                              href={
                                API_URL_DOWNLOAD + checkUrlTep(tep?.tepdinhkem)
                              }
                            >
                              <DownloadIcon />
                            </Link>
                          </Typography>
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <div className="w-full text-center mt-4 font-bold text-lg text-gray-950">
                    Không có thông tin tệp đính kèm
                  </div>
                )}
              </>
            ) : (
              <AddListFile
                dataDefault={data?.tepdinhkem}
                fileDel={fileDel}
                fileEditName={fileEditName}
                fileFields={fileFields}
                errors={errors}
                onDelete={handleOnDeleteFileDefault}
                onError={handleErrorFile}
                onFileChange={handleChangeFileList}
                nameFile="chamdiem"
                onEditName={handleEditFileNameDefault}
                onErrorDownload={handleErrorDownloadFile}
              />
            )}
          </CustomTabPanel>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            type="button"
            variant="contained"
            startIcon={<Cancel />}
            size="small"
            onClick={handelClear}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Hủy
          </Button>
          {!seen && (
            <Button
              type="submit"
              variant="contained"
              startIcon={<SaveIcon />}
              size="small"
              onClick={onSubmitForm}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Lưu
            </Button>
          )}
        </DialogActions>
      </Dialog>
    )
  );
}
const validateRequired = (value) => {
  let result = !!value?.length;
  if (typeof value == "number") {
    result = true;
  }
  return result;
};
const validateArrayRequired = (arrayValue) => {
  let result = [];
  if (arrayValue) {
    arrayValue.map((value, index) => {
      result.push("");
      if (!value?.length) result[index] = "Tên tệp không được trống";
    });
  }
  return result;
};
const validateFileEditName = (arrayValue) => {
  let result = {};
  if (arrayValue) {
    arrayValue.map((file, index) => {
      result[file?.id] = "";
      if (!file?.tentepdinhkem) result[file?.id] = "Tên tệp không được trống";
    });
  }
  return result;
};

function validateOBJ(thpd, dungluong) {
  let result = {
    soquyetdinh: !validateRequired(thpd.soquyetdinh)
      ? "Số quyết định không được trống"
      : "",

    ngay: !validateRequired(thpd.ngay)
      ? "Ngày ban hành trống hoặc sai định dạng"
      : "",
    ngaycham: !validateRequired(thpd.ngaycham)
      ? "Ngày chấm trống hoặc sai định dạng"
      : "",
    noidung: !validateRequired(thpd.noidung) ? "Nội dung không được trống" : "",
    tentepdinhkem: validateArrayRequired(thpd.tentepdinhkem),
    tepdinhkemValidate: validateArrayFileRequired(
      thpd.tepdinhkemValidate,
      dungluong
    ),
    tentepdinhkemEdit: validateFileEditName(thpd.tentepdinhkemEdit),
  };
  return result;
}
export default TongHopPhieuDiem;
